import TopNav from '@/pages/home/components/TopNav';
import Hero from '@/pages/home/components/Hero';
import QuickIndex from '@/pages/home/components/QuickIndex';
import FeaturedStory from '@/pages/home/components/FeaturedStory';
import StatStrip from '@/pages/home/components/StatStrip';
import TimelineFeed from '@/pages/home/components/TimelineFeed';
import RankAndCollections from '@/pages/home/components/RankAndCollections';
import CommentWall from '@/pages/home/components/CommentWall';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-sans text-foreground-950">
      <TopNav />
      <main>
        <Hero />
        <QuickIndex />
        <FeaturedStory />
        <StatStrip />
        <TimelineFeed />
        <RankAndCollections />
        <CommentWall />
      </main>
      <SiteFooter />
    </div>
  );
}